import React from 'react'
import RenderHTML from '../ui-components/RenderHTML'

interface EliteHelpRowProps {
  useCase: string
  elitePoints: {
    feature: string
    caption: string
  }[]
}

const EliteHelpRow: React.FC<EliteHelpRowProps> = ({ useCase, elitePoints }) => {
  return (
    <tr className='align-baseline border-b border-[#EBF2F2] text-[13px] font-[500] text-[#232323]'>
      <td className='pr-3 py-4 text-left '>{useCase}</td>
      <td className='pl-3 py-4'>
        <div className='flex flex-col gap-5'>
          {elitePoints?.map(({ feature, caption }, index) => {
            return (
              <div key={`${feature}-${index}`} className='flex flex-col'>
                <div className='flex items-center'>
                  <div className='w-4 h-4 rounded-full bg-[#CC5C2D] flex items-center justify-center mr-2'>
                    <svg width='10' height='8' viewBox='0 0 10 8' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <path
                        d='M8.43164 1.56836L4.00000 5.99966L1.56836 3.56802'
                        stroke='white'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </div>
                  <div>{feature}</div>
                </div>
                <div className='text-[12px] font-[400] text-[#8E9393] pt-1'>
                  {<RenderHTML innerHTMLText={caption} />}
                </div>
              </div>
            )
          })}
        </div>
      </td>
    </tr>
  )
}

export const EliteHelpsTable = () => {
  const rows: EliteHelpRowProps[] = [
    {
      useCase: 'Mutual Fund Selection',
      elitePoints: [
        {
          feature: 'Power Rank',
          caption: 'Unlock Top Ranked funds.<br />Skip the guesswork.'
        }
      ]
    },
    {
      useCase: 'Portfolio Review',
      elitePoints: [
        {
          feature: 'Rank Trends',
          caption: 'See if your funds are getting<br />better or worse'
        }
      ]
    },
    {
      useCase: 'Portfolio Rebalancing',
      elitePoints: [
        {
          feature: 'Power Rebalancing',
          caption: 'Get a tax-efficient <br />portfolio rebalancing plan'
        }
      ]
    }
  ]

  return (
    <div className='overflow-x-auto max-w-full'>
      <table className='table-auto w-full'>
        <thead>
          <tr>
            <th className='pr-3 text-left text-[#8E9393] text-[13px] font-[400]'>Use case</th>
            <th className='pl-3 text-[#8E9393] text-[13px] font-[400] text-left'>With Elite</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <EliteHelpRow key={`${row?.useCase}-${index}`} {...row} />
          ))}
        </tbody>
      </table>
    </div>
  )
}
